import { Reveal } from "@/components/Reveal";
import { SectionTag } from "@/components/SectionTag";
import { useLang } from "@/i18n/LangContext";

export const WhyMe = () => {
  const { t } = useLang();
  const w = t.home.whyMe;
  return (
  <section className="px-5 md:px-10 py-24 md:py-32 bg-sand/50" data-testid="why-me">
    <div className="mx-auto max-w-7xl">
      <div className="max-w-3xl">
        <SectionTag>{w.tag}</SectionTag>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-display text-3xl md:text-5xl font-bold tracking-tight text-balance">
            {w.h2}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-5 font-display text-lg md:text-xl font-semibold tracking-tight text-terracotta-deep">
            {w.subtitle}
          </p>
        </Reveal>
      </div>

      <div className="mt-16 md:mt-24 space-y-0">
        {w.chapters.map((c, i) => (
          <Reveal key={c.title} delay={0.05}>
            <div
              className={`grid gap-6 md:grid-cols-2 md:gap-16 items-start border-t border-ink/10 py-12 md:py-16 ${
                i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div className="flex items-baseline gap-6">
                <span className="font-display text-6xl md:text-8xl font-extrabold tracking-tighter text-terracotta/40">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-display text-2xl md:text-3xl font-bold tracking-tight text-balance">
                  {c.title}
                </h3>
              </div>
              <p className="text-base md:text-lg leading-relaxed text-plum/80 md:pt-4">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
